import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { CommonEnums } from "../../enums/common.enums";

// Define initial state shape explicitly (optional, improves clarity)
interface TemplatesState {
  selectedTemplateId: string;
  selectedTemplateIds: string[];
  templateDesignReset: boolean;
  subscriptionsTab: string;
  listingTab: string;
}

const initialState: TemplatesState = {
  selectedTemplateId: "",
  selectedTemplateIds: [],
  templateDesignReset: false,
  subscriptionsTab: CommonEnums.subscriptionType.property_marketing.key,
  listingTab: CommonEnums.listingType.for_rent.key,
};

export const templatesSlice = createSlice({
  name: "templates",
  initialState,
  reducers: {
    setSelectedTemplateId: (state, action: PayloadAction<string>) => {
      state.selectedTemplateId = action.payload;
    },
    resetTemplateDesign: (state) => {
      state.templateDesignReset = !state.templateDesignReset;
      state.selectedTemplateIds = [];
    },

    setSubscriptionsTab: (state, action: PayloadAction<string>) => {
      state.subscriptionsTab = action.payload;
    },
    setListingTab: (state, action: PayloadAction<string>) => {
      state.listingTab = action.payload;
    },
    addSelectedTemplateId: (state, action: PayloadAction<string>) => {
      if (!state.selectedTemplateIds.includes(action.payload)) {
        state.selectedTemplateIds.push(action.payload);
      }
    },
    removeSelectedTemplateId: (state, action: PayloadAction<string>) => {
      state.selectedTemplateIds = state.selectedTemplateIds.filter(
        (id) => id !== action.payload
      );
    },
    resetSelectedTemplateIds: (state) => {
      state.selectedTemplateIds = [];
    },
  },
});

export const templatesAction = templatesSlice.actions;
export const templatesReducer = templatesSlice.reducer;
